import { SaleTypes } from 'modules/_common/SaleTypes';

/**
 * Regras de compra do ingresso: quando a venda abre e quantas unidades cabem
 * num pedido.
 *
 * O início das vendas é do ingresso vendido por lote (`products.sale_start`);
 * no período de vendas o início fica em cada lote e este não vale. O estado do
 * formulário usa `opens_at` para não se misturar com o `sale_start` do período,
 * que mora no mesmo objeto.
 *
 * O máximo por compra espelha a API: de 1 até o limite geral por lote
 * (`order.ticket_limit_per_purchase`, 10), que a página do evento também aplica.
 */
export const MAX_PER_ORDER_LIMIT = 10;

/** Campos do formulário a partir do ingresso como o painel o recebe. */
export function purchaseRulesFromTicket(ticket) {
    const opensAt = ticket.sale_type !== SaleTypes.PERIOD ? ticket.sale_start || null : null;
    const maxPerOrder = ticket.max_per_order ?? null;

    return {
        has_sale_start: !!opensAt,
        opens_at: opensAt,
        has_max_per_order: maxPerOrder !== null,
        max_per_order: maxPerOrder !== null ? String(maxPerOrder) : '',
    };
}

export const EMPTY_PURCHASE_RULES = {
    has_sale_start: false,
    opens_at: null,
    has_max_per_order: false,
    max_per_order: '',
};

export function hasSaleStart(ticket) {
    return ticket.sale_type !== SaleTypes.PERIOD && !!ticket.has_sale_start;
}

export function isMaxPerOrderValid(value) {
    const quantity = Number(value);

    return Number.isInteger(quantity) && quantity >= 1 && quantity <= MAX_PER_ORDER_LIMIT;
}

export function isPurchaseRulesValid(ticket) {
    const isSaleStartValid = !hasSaleStart(ticket) || !!ticket.opens_at;
    const isMaxValid = !ticket.has_max_per_order || isMaxPerOrderValid(ticket.max_per_order);

    return isSaleStartValid && isMaxValid;
}

/** Sempre manda os dois campos: desligar a chave limpa o que estava salvo. */
export function purchaseRulesPayload(ticket) {
    return {
        sale_start: hasSaleStart(ticket) ? ticket.opens_at : null,
        max_per_order: ticket.has_max_per_order ? Number(ticket.max_per_order) : null,
    };
}
